import { useGetIsAuthUser } from '@/shared/hooks/useGetIsAuthUser.js'
import {
    useCheckUserMutation,
    useCreateReviewMutation,
} from '@/shared/api-rtk/index.js'
import { useEffect, useState } from 'react'
import { validationReviewsForm } from '@/shared/validation/validationReviewsForm.js'
import './ReviewsForm.scss'
import { TOAST_ERROR } from '@/shared/constants/toastTypes.js'

const ReviewsForm = ({ productId, productName }) => {
    const { userInfo } = useGetIsAuthUser()
    const [checkProfile] = useCheckUserMutation()
    const [addReview] = useCreateReviewMutation()

    const [submittedForm, setSubmittedForm] = useState({
        reviewNumber: null,
        value: false,
    })
    const [formData, setFormData] = useState({
        name: '',
        product_id: productId,
        text: '',
    })
    const [formValidation, setFormValidation] = useState({
        name: false,
        text: false,
    })

    useEffect(() => {
        if (userInfo) {
            checkProfile(userInfo)
                .unwrap()
                .then((res) => {
                    if (res.result === 'success') {
                        setFormData({
                            ...formData,
                            name:
                                `${res.data.firstname} ${res.data.lastname}` ||
                                res.data.email,
                        })
                    }
                })
        }
    }, [])

    const submitForm = (e) => {
        e.preventDefault()

        const validationForm = validationReviewsForm(
            formData,
            setFormValidation
        )
        if (validationForm) {
            addReview(formData)
                .unwrap()
                .then((res) => {
                    if (res.result === 'success') {
                        setSubmittedForm({
                            value: true,
                            reviewNumber: res.data,
                        })
                    }
                })
                .catch(() =>
                    TOAST_ERROR('Не удалось оставить отзыв. Попробуйте позже')
                )
        }
    }

    return (
        <div className={'ReviewsForm'}>
            {submittedForm.value && (
                <h2>Отзыв №{submittedForm.reviewNumber} отправлен!</h2>
            )}
            {!submittedForm.value && (
                <>
                    <div className={'info-text'}>
                        <img src="/icons/question-info-icon.svg" alt="icon" />
                        <p>Оставьте отзыв о данном товаре</p>
                    </div>
                    <form className={'review-form'} onSubmit={submitForm}>
                        <div className={'input-container'}>
                            <input
                                type="text"
                                name="name"
                                className={`input ${
                                    formValidation.name ? 'error-input' : ''
                                }`}
                                value={formData.name}
                                placeholder="Введите ваше имя"
                                onChange={(e) => {
                                    setFormData({
                                        ...formData,
                                        name: e.target.value,
                                    })
                                    setFormValidation({
                                        ...formValidation,
                                        name: false,
                                    })
                                }}
                            />
                            {formValidation.name && (
                                <span className={'error-text'}>
                                    Введите ваше имя
                                </span>
                            )}
                        </div>
                        <div className={'input-container'}>
                            <input
                                type="text"
                                name="product"
                                className={`input`}
                                value={productName}
                                disabled={true}
                                placeholder="Наименование товара"
                            />
                        </div>
                        <div className={'input-container'}>
                            <textarea
                                name="review"
                                className={`input ${
                                    formValidation.text ? 'error-input' : ''
                                }`}
                                placeholder="Введите ваше сообщение"
                                onChange={(e) => {
                                    setFormData({
                                        ...formData,
                                        text: e.target.value,
                                    })
                                    setFormValidation({
                                        ...formValidation,
                                        text: false,
                                    })
                                }}
                            />
                            {formValidation.text && (
                                <span className={'error-text'}>
                                    Введите ваше сообщение
                                </span>
                            )}
                        </div>
                        <button type={'submit'}>Оставить отзыв</button>
                    </form>
                </>
            )}
        </div>
    )
}

export default ReviewsForm
